export default "assets/example-4.c48b7d719a357997.png"